import { CompanyFinance } from "modules/companyAdmin";

const CompanyAdminFinancialPage = () => <CompanyFinance />;

export default CompanyAdminFinancialPage;
